import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { STATES_OBJECTIVES } from '../../constants';

export interface ObjetivoUI {
  _id: string;
  nombre: string;
  dimension: string;
  inicio: string;
  fin: string;
  porcentaje: number;
  activities?: ActividadUI[];
  state: string; // 'Nuevo', 'Empezado', 'Terminado'
  startRaw?: string;
  endRaw?: string;
}

export interface ActividadUI {
  nombre: string;
  descripcion: string;
  progreso: number;
  estado: string;
  inicio: string;
  fin: string;
}

@Component({
  selector: 'app-progress-summary',
  standalone: true,
  templateUrl: './progress-summary.component.html',
  styleUrl: './progress-summary.component.scss',
  imports: [CommonModule, FormsModule]
})
export class ProgressSummaryComponent {
  // Inputs
  private _objetivos = signal<ObjetivoUI[]>([]);

  @Input()
  set objetivos(value: ObjetivoUI[]) {
    this._objetivos.set(value);
  }

  get objetivos(): ObjetivoUI[] {
    return this._objetivos();
  }

  @Input() autoconocimientoProgress = 0;
  // @Input() objetivos: ObjetivoUI[] = [];
  @Input() actividades: ActividadUI[] = [];
  @Input() estadosFiltro: string[] = ['Todos', 'Nuevo', 'Empezado', 'Terminado'];
  @Input() isUserFreemium = false;
  @Input() showObjectivesAndActivities = true;
  @Input() isDisabledCreateObjectiveButton = true;

  // Outputs
  @Output() crearObjetivo = new EventEmitter<void>();
  @Output() verTodosObjetivos = new EventEmitter<void>();
  @Output() filtroChange = new EventEmitter<string>();

  // Estado local
  estadoSeleccionado = 'Todos';

  // Computed property para filtrar objetivos
  objetivosFiltradosDisplay = computed(() => {
    const todos = this.objetivos;
    // if (this.estadoSeleccionado === 'Todos') {
    return todos.slice(0, 5);
    // }

    // let estadoFiltro = '';
    // switch (this.estadoSeleccionado.trim()) {
    //   case 'Nuevo':
    //     console.log('Filtrando por estado: Nuevo');
    //     estadoFiltro = STATES_OBJECTIVES.Nuevo.name;
    //     break;
    //   case 'Empezado':
    //     estadoFiltro = STATES_OBJECTIVES.Empezado.name;
    //     break;
    //   case 'Pendiente':
    //     estadoFiltro = STATES_OBJECTIVES.Pendiente.name;
    //     break;
    //   case 'Terminado':
    //     estadoFiltro = STATES_OBJECTIVES.Realizado.name;
    //     break;

    // }

    // const filtrados = todos.filter(objetivo => objetivo.state === estadoFiltro);

    // return filtrados.slice(0, 5);
  });

  objetivosProgress(){
    if(this.objetivos.length === 0) {
      return 0;
    }

    if(this.objetivos.every(objetivo => objetivo.porcentaje === 100)) {
      return 100;
    }

    if(this.objetivos.some(objetivo => objetivo.porcentaje === 100)) {
      return 50;
    }

    if(this.objetivos.some(objetivo => objetivo.porcentaje > 0)) {
      return 25;
    }

    return 0;
  }

  onCrearObjetivo() {

    this.crearObjetivo.emit();

  }

  onVerTodosObjetivos() {
    this.verTodosObjetivos.emit();
  }

  onFiltroChange(estado: string) {
    this.estadoSeleccionado = estado;
    this.filtroChange.emit(estado);
  }
}